const e=(e,t,n,r,i)=>t.find(t=>t.condition(e))?.transform(e,n,r,i),t=e=>`examples`in e&&Array.isArray(e.examples)&&e.examples.length>0?e.examples[0]:``;export{e as applyTransform,t as getSampleData};
//# sourceMappingURL=utils.js.map